
import { ProgressSpinner } from 'primereact/progressspinner'
import './style.css'
const SplashScreen = () => {
  return (
    <div className='flex flex-column align-items-center justify-content-center' style={{height: '100vh'}}>
      <img src="/LOGITEMP2.png" className='zoom-animation'  alt="LOGITEMP2" style={{width: '300px' }} />
      {/* <img src={} class="light-logo" alt="LOGITEMP2" /> */}
      <ProgressSpinner animationDuration={1000} strokeWidth='3' />
    </div>
  )
}

export default SplashScreen